var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInformation = function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#f6f6fa",
    strokeLinecap: "round",
    d: "M7.499 11.389V6.722"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.499,
    cy: 4.389,
    r: 0.778,
    fill: "#f6f6fa"
  })));
};
export default SvgInformation;